import React from "react";
import AuthUserContext from "./context";
import { withFirebase } from "../Firebase";
import { initializePush, addIOSFCMToken } from "../Firebase/initializePush";
import { isIOS } from "../../utils";
import Loading from "../../components/Base/Loading";

const withAuthentication = (Component) => {
  class WithAuthentication extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        authChecking: false,
        authUser: null,
        isFaculty: false,
        profile: null,
        loginFailed: false,
        school: null,
      };
    }

    async componentDidMount() {
      window.app = this;
      this.authListener = this.props.firebase.auth.onAuthStateChanged(
        async (authUser) => {
          authUser
            ? this.setState({ authUser, authChecking: true })
            : this.setState({ authUser: null, authChecking: true });
          if (authUser) {

            let snapshot =  await this.props.firebase.faculties().where("auth_uid", "==", authUser.uid).get()
            if (snapshot.docs && snapshot.docs.length > 0) {
              this.login(snapshot.docs[0], true)
              return
            }

            snapshot = await this.props.firebase.students().where("auth_uid", "==", authUser.uid).get()
            if (snapshot.docs && snapshot.docs.length > 0) {
              this.login(snapshot.docs[0], false)
              return
            }

            // match account
            snapshot = await this.props.firebase.faculties().where("email", "==", authUser.email).get()
            if (snapshot.docs && snapshot.docs.length > 0) {
              let doc = snapshot.docs[0]
              await doc.ref.update({ auth_uid: authUser.uid })
              this.login(doc, true)
              return
            }

            snapshot = await this.props.firebase.students().where("email", "==", authUser.email).get()
            if (snapshot.docs && snapshot.docs.length > 0) {
              let doc = snapshot.docs[0]
              await doc.ref.update({ auth_uid: authUser.uid })
              this.login(doc, false)
              return
            }

          }
        });
      }

    login = (doc, isFaculty) => {
      let profile = {
        id: doc.id,
        ...doc.data(),
      };
      isFaculty ? localStorage.setItem("role", "faculty") : localStorage.setItem("role", "student")
      localStorage.setItem("uid", profile.id);
      this.setState({
        isFaculty: isFaculty,
        profile: profile,
        loginFailed: false,
        authChecking: false,
      });
      this.fetchSchoolInfo();
      if (isIOS()) {
        try {
          window.ReactNativeWebView.postMessage("isWebViewLoaded");
        } catch (error) {
          //console.log("IOS Wrapper Bridge Error: ", error);
        }
      } else {
        initializePush(this.props.firebase, isFaculty, profile);
      }     
    }

    fetchSchoolInfo = async () => {
      try {
        localStorage.setItem("school", "jm8UXoTsw4npkBtdWwoL");
        let dorms = [];
        let dormMap = {};

        let subDorms = [];
        let subDormMap = {};

        let leaveTypes = {};
        let typeList = [];

        let transportTypes = [];

        let locationList = [];
        let locationMap = {};

        let schoolRef = await this.props.firebase.school(
          "jm8UXoTsw4npkBtdWwoL"
        );

        schoolRef
          .collection("dorms")
          .get()
          .then((snapshot) => {
            if (snapshot.docs) {
              snapshot.docs.forEach((doc) => {
                let dorm_id = doc.id;
                let dorm_data = doc.data();
                let sub_dorms = [];
                dormMap[dorm_id] = dorm_data;
                schoolRef
                  .collection("dorms")
                  .doc(dorm_id)
                  .collection("sub_dorms")
                  .get()
                  .then((snapshot) => {
                    if (snapshot.docs) {
                      snapshot.docs.forEach((doc) => {
                        let sub_dorm_id = doc.id;
                        let sub_dorm_data = doc.data();
                        subDorms.push({ id: sub_dorm_id, ...sub_dorm_data });
                        subDormMap[sub_dorm_id] = sub_dorm_data;
                        sub_dorms.push({
                          id: sub_dorm_id,
                          ...sub_dorm_data,
                        });
                      });
                    }
                  });
                dorms.push({ id: dorm_id, sub_dorms: sub_dorms, ...dorm_data });
              });
            }
          });

        schoolRef
          .collection("leave_types")
          .get()
          .then((snapshot) => {
            if (snapshot.docs) {
              snapshot.docs.forEach((doc) => {
                let leave_type_id = doc.id;
                let leave_type_data = doc.data();
                typeList.push({ id: leave_type_id, ...leave_type_data });
                leaveTypes[leave_type_id] = leave_type_data;
              });
            }
          });

        schoolRef
          .collection("transportation_types")
          .get()
          .then((snapshot) => {
            if (snapshot.docs) {
              snapshot.docs.forEach((doc) => {
                let transport_type_id = doc.id;
                let transport_type_data = doc.data();
                transportTypes.push({
                  id: transport_type_id,
                  ...transport_type_data,
                });
              });
            }
          });

        schoolRef
          .collection("locations")
          .get()
          .then((snapshot) => {
            if (snapshot.docs) {
              snapshot.docs.forEach((doc) => {
                let location_id = doc.id;
                let location_data = doc.data();
                locationList.push({ id: location_id, ...location_data });
                locationMap[location_id] = location_data;
              });
            }
          });

        const schoolData = await schoolRef.get();

        const locations = {
          list: locationList,
          map: locationMap,
        };
        const leaves = {
          types: { list: typeList, map: leaveTypes },
          transport: { list: transportTypes },
        };

        const school = {
          id: schoolData.id,
          ...schoolData.data(),
          dorms,
          dormMap,
          leaveTypes,
          transportTypes,
          typeList,
          locations,
          leaves,
          subDormMap,
          subDorms,
        };
        this.setState({ school: school });
      } catch (err) {
        //console.log("auth failed", err);
      }
    };

    _setNativeToken = (token) => {
      const { isFaculty, profile } = this.state;
      if (token) addIOSFCMToken(this.props.firebase, isFaculty, profile, token);
    };

    componentWillUnmount() {
      this.authListener();
    }

    render() {
      const {
        isFaculty,
        profile,
        authUser,
        authChecking,
        loginFailed,
        school,
      } = this.state;

      return (
        <AuthUserContext.Provider value={this.state.authUser}>
          {authChecking || (profile && school) ? (
            <Component
              {...this.props}
              loginFailed={loginFailed}
              isFaculty={isFaculty}
              profile={profile}
              authUser={authUser}
              checking={authChecking}
              school={school}
            />
          ) : (
            <Loading />
          )}
        </AuthUserContext.Provider>
      );
    }
  }

  return withFirebase(WithAuthentication);
};

export default withAuthentication;
